import { ChangeDetectionStrategy, Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { find } from 'browser-langs';
import { LanguageSettingsService } from '@app/core/settings/language/language-settings.service';
import { SettingsService } from '@app/core/settings/settings.service';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent implements OnInit, OnDestroy {
  private languageSettings = inject(LanguageSettingsService);
  private settingsService = inject(SettingsService);

  public findLang = find;
  public languages = input.required<string[]>();

  protected formControl!: FormControl;
  private formSub: Subscription;

  public ngOnInit(): void {
    this.formControl = new FormControl(this.getDefaultLanguage() || 'default');
    this.formSub = this.formControl.valueChanges.subscribe((lang: string) => this.formControlChange(lang));
  }

  public ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  private formControlChange(language: string): void {
    this.languageSettings.storeLanguage(language);
  }

  private getDefaultLanguage(): string | void {
    const currentLanguage = this.settingsService.settings.locale;

    if (this.languages().includes(currentLanguage)) { return currentLanguage; }
  }
}
